module.exports = __webpack_public_path__ + "static/media/thanksforallthefish.704119c2.md";